import { useWindowResize } from '@one-snap/core';

export const useIsViewMobile = () => {
  const { width } = useWindowResize();

  return { isViewMobile: width <= 768 };
};

export default useIsViewMobile;
